export const copyText = {
  data() {
    return {};
  },
  methods: {
    onCopy(e) {
      const button = e.trigger;
      const text = button.querySelector(".v-btn__content");
      this.deactivateBtn(button, text);
      this.$store.dispatch("ui/snackbar", [
        {
          title: "",
          message: "Forward email has been copied to your clipboard",
          type: "success",
        },
      ]);

      setTimeout(() => {
        this.reactivateBtn(button, text);
      }, 3000);
    },
    deactivateBtn(button, text) {
      button.setAttribute("disabled", "disabled");
      button.classList.add("v-btn--disabled");
      button.classList.add("theme--light");
      text.innerText = "Copied";
    },

    reactivateBtn(button, text) {
      button.removeAttribute("disabled");
      button.classList.remove("v-btn--disabled");
      text.innerText = "Copy";
    },
  },
};
